import { useContext, memo, useState, useEffect } from "react";
import "./style.css";
import { SetLocStorage } from "../../utils";
import { Image } from "../../components/crRender";
import { PrivilegeContext } from "../../context/PrivilegesContext";
import ActionMenu from "./ActionMenu";
import { GetUserInfo } from "../../api/endpoints";

import logo from "@assets/auth/Logo.png";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react/dist/iconify.js";
import Notifications from "./Notifications";

const Header = () => {
  const [userTab, setUserTab] = useState(false);

  const { userName, setUserName, setRoleName, roleName, isLoggedIn } =
    useContext(PrivilegeContext);
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!isLoggedIn) return;
    GetUserInfo().then((res) => {
      setUserName(res.data.userName);
      setRoleName(res.data.roleName);
      SetLocStorage("userName", res.data.userName);
      SetLocStorage("RoleName", res.data.roleName);
    });
  }, [isLoggedIn]);

  const handleChangeLanguage = () => {
    var newLanguage = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLanguage);
    SetLocStorage("i18nextLng", newLanguage);
  };

  return (
    <nav className="navbar navbar-expand-lg ">
      <div className="container-fluid">
        

        <div className="d-flex justify-content-start align-items-center gap-3">
          <div className="right-part">
          <Image className={"logo"} src={logo} />
        </div>
        <div className="language-selector" onClick={handleChangeLanguage}>
          <Icon icon={`gis:earth`} />
          <div className="language-selector-text">
            {i18n.language === "ar" ? "EN" : "AR"}
          </div>
        </div>
          </div>
        <div className="d-flex justify-content-start align-items-center gap-3">
          {/* <Notifications /> */}
          <div className={`left-part`} onClick={() => setUserTab((e) => !e)}>
            <div className="user-details">
              <div className="user-info">
                <span className="user-name">
                  <Icon
                    icon="octicon:person-16"
                    className="account-icon Icon"
                  />
                  {userName}
                </span>
                <span className="user-name">{roleName}</span>
              </div>
            </div>

            <Icon
              className="user-setting"
              icon={`fluent:chevron-${!userTab ? "down" : "up"}-16-filled`}
            />

            <ActionMenu userTab={userTab} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default memo(Header);
